<template>
	<div :class="$style['form-section']">
		<div
			v-if="title || $slots['title-actions']"
			:class="$style['form-section__header']"
		>
			<p v-if="title" :class="$style['form-section__title']">
				{{ title }}
			</p>
			<div
				v-if="$slots['title-actions']"
				:class="$style['form-section__title-actions']"
			>
				<slot name="title-actions" />
			</div>
		</div>
		<div :class="$style['form-section__content']">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'FormSection',
	props: {
		title: {
			type: String,
			default: null
		}
	}
}
</script>

<style lang="scss" module>
.form-section {
	padding: 20px;
	border: 1px solid getColor(border);
	border-radius: 12px;
	// background: #fafafa;
	background: getColor(surface-elevated-high);
	margin-bottom: $gutter * 2;

	@include dark-mode-border-fix(border);

	&:last-child {
		margin-bottom: 0;
	}

	&__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: $gutter;
		margin: 0 0 $gutter * 2;
		flex-wrap: nowrap;
	}

	&__title {
		margin: 0;
		flex: 1;
		min-width: 0;
		font-size: 14px;
		font-weight: 700;
		line-height: 20px;
		color: getColor(text);
	}

	&__title-actions {
		display: flex;
		align-items: center;
		gap: $gutter;
		margin-left: auto;
		flex-shrink: 0;
	}

	&__content {
		// display: grid;
		// grid-template-columns: 1fr;
		// gap: 16px;

		// @include media-breakpoint-up(sm) {
		// 	grid-template-columns: repeat(2, minmax(0, 1fr));
		// }

		// @include media-breakpoint-up(lg) {
		// 	grid-template-columns: repeat(3, minmax(0, 1fr));
		// }

		// > :global(.input-group) {
		// 	grid-column: 1 / -1;
		// }

		// > :global(.grid) {
		// 	grid-column: 1 / -1;
		// }
	}
}
</style>
